module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("kvYrT"))).then(() => parcelRequire('hEqeo'));